import { SxProps, Theme } from "@mui/material";

export const dialogPaperSx: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  height: "100dvh",
  maxHeight: "100dvh",
  borderRadius: 0,
  backgroundColor:
    theme.palette.mode === "dark" ? "#000" : theme.palette.background.default,
});

export const dialogTitleSx: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor:
    theme.palette.mode === "dark" ? "#000" : theme.palette.background.paper,
  color: theme.palette.text.primary,
  borderBottom: `1px solid ${
    theme.palette.mode === "dark"
      ? "rgba(255,255,255,0.12)"
      : "rgba(15, 23, 42, 0.14)"
  }`,
  py: { xs: 0.5, sm: 0.75 },
  px: { xs: 0.75, sm: 1.5 },
  minHeight: { xs: 40, sm: 48 },
  paddingTop: {
    xs: "max(8px, calc(0.5rem + env(safe-area-inset-top, 0px)))",
    sm: "12px",
  },
  position: "relative",
  zIndex: 10,
  flexShrink: 0,
  "@media (orientation: landscape) and (max-height: 500px) and (pointer: coarse)":
    {
      py: 0.25,
      px: 0.5,
      minHeight: 32,
      paddingTop: "max(4px, calc(0.25rem + env(safe-area-inset-top, 0px)))",
    },
});

export const dialogContentSx: SxProps<Theme> = (theme) => ({
  p: 0,
  flex: 1,
  minHeight: 0,
  backgroundColor:
    theme.palette.mode === "dark" ? "#000" : theme.palette.background.default,
  overflow: "hidden",
  paddingBottom: {
    xs: "env(safe-area-inset-bottom, 0px)",
    sm: 0,
  },
  position: "relative",
});
